import React, { useEffect } from 'react';

const OutbrainHeadTags = ({ permalink }) => {
    const hostname = window.location.hostname;

    useEffect(() => {
        // Load Outbrain script if on wellcarespot.com
        if (hostname === 'wellcarespot.com') {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = '//widgets.outbrain.com/outbrain.js';
            document.body.appendChild(script);

            return () => {
                // Cleanup script on unmount
                if (document.body.contains(script)) {
                    document.body.removeChild(script);
                }
            };
        }
    }, [hostname]);

    // Only render for wellcarespot.com
    if (hostname !== 'wellcarespot.com') {
        return null;
    }

    return (
        <div 
            className="OUTBRAIN" 
            data-src={permalink || window.location.href} 
            data-widget-id="AR_1"
        />
    );
};

export default OutbrainHeadTags;